export const TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS';
export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND';

export type ResendFailureReason =
  | typeof TOO_MANY_ATTEMPTS
  | typeof EMAIL_NOT_FOUND;
